(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/utils/misc.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/utils/misc.js');

'use strict';

svs.tur.payment.utils.misc = {
  formatCurrency(value) {
    return svs.utils.format.CurrencyFromJupiterString(value);
  },
  addOwningGrammarApostrophe(name) {
    return name.slice(-1) === 's' ? name : "".concat(name, "s");
  },
  uppercaseFirst(string) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
  },
  createQueryString(params) {
    if (typeof params !== 'object') {
      return '';
    }
    return "?".concat(Object.keys(params).map(key => "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]))).join('&'));
  },
  setURLParams(params) {
    if (typeof params === 'object') {
      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key) && typeof params[key] !== 'undefined') {
          svs.utils.paramHandler.set({
            key,
            value: params[key]
          });
        }
      }
    }
  },
  isPayAfterDeposit() {
    const isPayAfterDeposit = svs.utils.paramHandler.get({
      key: 'afterpay'
    }).value;
    svs.utils.paramHandler.remove({
      key: 'afterpay'
    });
    return Boolean(isPayAfterDeposit);
  }
};

 })(window);